/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Sair do CD
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 12/04/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.Complete = function (
  {
    parentSelector = '#RouteSummary',
    successCallback
  } = {}
) {

    this.modalForm = null;
    this.route = null;
    this.blockOverlaySelector = '.mainContainer';

    this.show = function () {
        this.modalForm.showModalForm();
    };

    this.getLayout = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": Monet.I18n.getResourcesByKey('greenmile.route.complete.btnsave'),
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },


                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": data.dateTimeField.name,
                                                        "value": data.dateTimeField.value,
                                                        "name": data.dateTimeField.name,
                                                        "class": "dateTimePicker"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.drivers.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.drivers.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": data.drivers.name,
                                                        "id": data.drivers.name
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnSaveValue,
                                                        "name": "btn_save_complete_stop",
                                                        "id": "btn_save_complete_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnExitValue,
                                                        "name": "btn_exit_complete_stop",
                                                        "id": "btn_exit_complete_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formCompleteFormTemplate"
                    }
                }
            ]
        }).render();
    };

    this.setRoute = function (route) {
        this.route = route;
    };

    /**
     * Faz algumas modificações no ambiente onde o modal será inserido, nesse caso, modifica
     * o CSS do overlay para que ele se ajuste ao esquema de posicionamento dessa aba.
     */

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    /**
     * Monta a estrutura base do formulário, pega o template e insere o conteúdo no modalForm
     */

    this.createForm = function () {
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        const date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {
            modalContainer.appendChild(this.getLayout({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Route.Complete.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Route.Complete.btnExit'),
                dateTimeField: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.Complete.dateTimeFieldLabel'),
                    name: 'completeTime',
                    value: date.getCurrentDateAndTime()
                },
                drivers: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.Complete.driversList'),
                    name: 'driversList'
                }
            }));
            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);
        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }

    };

    this.loadData = function () {
        const that = this;
        const data = {
          criteriaChain: [
            {
              and: [
                {
                  attr: "route.id",
                  eq: this.route.get("id")
                }
              ]
            }
          ]
        };

        const request = new DefaultRequest({
            url: 'RouteDriver/restrictions?criteria={"filters" : ["*","driver.name", "driver.id"]}',
            method: 'post',
            data,
            success: function (data) {

                that.populateDriversList(data);

            }
        });
        request.send();

    };

    this.populateDriversList = function (drivers) {

        var undeliverableCodeElement = document.querySelector("#formCompleteFormTemplate #driversList");
        var driverLabel = document.querySelector("label[for='driversList']");
        var error = null;

        if (typeof(drivers) !== "undefined") {

            if (drivers.length > 0) {

                driverLabel.style.display = 'block';

                undeliverableCodeElement.innerHTML = "";

                for (var i = 0, j = drivers.length; i < j; i++) {

                    var option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);
                }
            } else {

                driverLabel.style.display = 'none';

            }

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();
        }

    };

    this.addEventListenners = function () {

        try {
            var error = null;
            var that = this;
            var btnSave = document.querySelector("#formCompleteFormTemplate #btn_save_complete_stop");
            var btnExit = document.querySelector("#formCompleteFormTemplate #btn_exit_complete_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doComplete();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.");
            error.console();

        }

    };

    this.doComplete = function () {

        var isValid = this.validateForm();
        var formValues = {};
        var that = this;
        var error = null;

        if (isValid) {

            formValues = this.getFormValues();

            var requestBody = {
                actualComplete: formValues.actualComplete
            };

            if (this.route !== null) {
                this.modalForm.toggleLoadingInModalBtn();

                const request = new DefaultRequest({
                    url: 'Route/' + this.route.get("id") + '/Complete' + (formValues.driverId ? '?driverId=' + formValues.driverId : ''),
                    method: 'post',
                    data: requestBody,
                    success: function (data) {
                        that.modalForm.closeModalWindow();
                        that.successCallback(data);
                    },
                    error: function (data) {

                        var returnObj = JSON.parse(data.responseText);
                        that.modalForm.toggleLoadingInModalBtn();

                        if (returnObj.errorMessages[0].resource.i18nMessage) {
                            that.errorCallback(data);
                        } else {
                            that.modalForm.closeModalWindow();
                            that.successCallback(data);
                        }

                    }

                });

                request.send();

            } else {
                error = new Monet.Exception.ReturnError(this,
                    "route can't be null");
                error.console();
            }
        }

    };

    this.getFormValues = function () {
        var completeTimeField = document.querySelector("#formCompleteFormTemplate .dateTimePicker");
        var driver = document.getElementById("driversList");
        var formattedDate = Monet.Format.DateTime.parseLocaleToISOString(completeTimeField.value);

        var objToSend = {
            actualComplete: formattedDate
        };

        if (driver !== null) {
            objToSend.driverId = Number(driver.value);
        }

        return objToSend;
    };

    this.successCallback = function () {
      if (parentSelector === '#RouteSummary') {
        const router = new App.Routers.RouteSummaryRoutes();

        Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');

        if(Monet.Session.Grids.Route && Monet.Session.Grids.Route.data){
            delete Monet.Session.Grids.Route.data;
        }

        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, true);
      } else {
        successCallback?.();
      }
    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope("#formCompleteFormTemplate");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

    this.validateForm = function () {

        var isValid = true;
        var error = null;
        var completeTime = document.getElementById("completeTime");
        var actualComplete = this.route.get("actualComplete");
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formCompleteFormTemplate';

        var formatToCreate = Monet.I18n.locale.dateFormat + ' ' + Monet.I18n.locale.timeFormat;
        var completeTimeTimeMili = null;

        try {

            if (completeTime.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "complete_date",
                    "Route.Complete.cantCompleteWhitouDateTime"
                );

                isValid = false;

            } else {

                completeTimeTimeMili = Monet.Format.DateTime.parseLocale(completeTime.value).getTime();
                if (typeof(actualComplete) !== "undefined") {

                    utils.showErrorMessage(
                        scopeMessage,
                        "already_completeed",
                        "Route.Complete.cantCompleteCompleteedRoute"
                    );

                    isValid = false;

                } else {

                    if (completeTimeTimeMili >= new Date().getTime()) {

                        utils.showErrorMessage(
                            scopeMessage,
                            "driver",
                            "Route.Complete.cantDoItTheFuture"
                        );

                        isValid = false;

                    }
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadData();
            scope.addEventListenners();
        };
    }(this);

    var init = function (scope) {

        return function (scope) {

            const selector = parentSelector;

            const options = {
                width: 280,
                height: 250
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);

};
